export function localAuthBypassEnabled(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_SKIP_AUTH === "1";
}
